"use client";

import { useAppSelector } from "@/hooks/useAppSelector";
import {  CircularProgress } from "@mui/material";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import MobileNavigation from "./mobile/home/MobileNavigation";
import { useDevice } from "@/hooks/useDevice";
// import MobileNavigation from "./mobile/home/MobileNavigation";
// import { useDevice } from "@/hooks/useDevice";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const router = useRouter();
  const pathname = usePathname(); // ✅ Get the current route pathname
  const { bulkUserID, isAuthenticated } = useAppSelector(
    (state) => state?.auth
  );

  const [checkingAuth, setCheckingAuth] = useState<boolean>(true);
  const isMobile = useDevice();

  useEffect(() => {
    // List of protected route patterns
    const protectedPatterns = [
      /^\/user\/.*/, // All routes starting with /user/
      /^\/checkout\/cart\/(?!$).*/, // Any subroutes under /checkout/cart/
      /^\/checkout\/address$/, // Exact /checkout/address
      /^\/checkout\/payment$/, // Exact /checkout/payment
    ];

    const isProtected = protectedPatterns.some(
      (pattern) => pattern.test(pathname) // ✅ Use `pathname` instead of `router.pathname`
    );

    if (pathname === "/auth" && isAuthenticated) {
      router.push("/");
    } else if (pathname === "/onboarding" && !bulkUserID) {
      router.push("/onboarding");
      setCheckingAuth(false);
    } else if (pathname === "/onboarding" && bulkUserID) {
      router.push("/");
    } else if (isProtected) {
      if (isAuthenticated && (!bulkUserID || bulkUserID === "")) {
        router.push("/onboarding");
      } else if (!isAuthenticated && (!bulkUserID || bulkUserID === "")) {
        router.push("/auth");
      } else {
        setCheckingAuth(false); // ✅ Set checkingAuth to false only after validation
      }
    } else {
      setCheckingAuth(false);
    }
  }, [pathname, router, bulkUserID, isAuthenticated]);


  if (checkingAuth) {
    return (
      <div className="flex h-screen text-blue items-center justify-center text-lg">
        <CircularProgress size={20} sx={{ color: "var(--color-blue)" }} />
      </div>
    );
  }

  return (
    <>
      {/* Conditionally render message on mobile/tablet */}
      {/* {isMobileOrTablet ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white-1 text-blue py-4 px-6 text-center">
          <Box display="flex" flexDirection="column" alignItems="center">
            <HourglassTop fontSize="large" className="animate-spin text-blue" />
            <h2 className="font-bold text-xl mt-4">
              For the best experience, please open this website on a desktop.
            </h2>
          </Box>
        </div>
      ) : (
        children
      )} */}
      {children}
      {isMobile && (pathname === "/" || pathname.startsWith("/user/")) && (
        <MobileNavigation />
      )}
    </>
  );
};

export default ProtectedRoute;
